export default "<img [src]=\"media.examQuestionMediaUrl\">";